import React from "react";
import { useSelector } from "react-redux";
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import useStyles from "./Styles/NavBarStyles";
import { PROFILE_TABS } from "../../constants";
import { CustomStyledList } from "./Styles/NavBarStyles";
import ProfileNavbarSkeleton from "../../components/skeletons/ProfileNavbar";

export function NavBar({ selectedTab, setSelectedTab }) {
    const classes = useStyles();
    const user = useSelector(state => state.authentication.current_user);
    const { DASHBOARD, TEAM_PAGES, USER_PAGES, DONATION_HISTORY, SETTINGS } = PROFILE_TABS

    const tabs = [
        { id: DASHBOARD, text: "Dashboard", icon: <DashboardIcon /> },
        { id: TEAM_PAGES, text: "Team Fundraisers", icon: <GroupsIcon />, count: user?.userStats?.total_team_fundraiser_pages || 0 },
        { id: USER_PAGES, text: "Personal Fundraisers", icon: <PersonIcon />, count: user?.userStats?.total_fundraiser_pages || 0 },
        { id: DONATION_HISTORY, text: "Donation History", icon: <VolunteerActivismIcon />, count: user?.userStats?.total_donations_count || 0 },
        { id: SETTINGS, text: "Settings", icon: <SettingsIcon /> },
    ]

    const mapTabs = () => {
        return tabs.map(tab => {
            return <ListItem disablePadding key={tab.id}>
                <ListItemButton selected={selectedTab == tab.id} onClick={() => setSelectedTab(tab.id)}>
                    <ListItemIcon>
                        {tab.icon}
                    </ListItemIcon>
                    <ListItemText primary={`${tab.text} ${tab.count ? "(" + tab.count + ")" : ""}`} />
                </ListItemButton>
            </ListItem>
        })
    }

    return <Box className={classes.root}>
        <CustomStyledList disablePadding>
            {user?.userStats ? mapTabs() : <ProfileNavbarSkeleton />}
        </CustomStyledList>
    </Box>
}